import {useInfiniteQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetExternalCosts} from '../http/budget.http'
import {infiniteQueryFetchNextPage} from '@/utilities/helpers'

export const useGetExternalCosts = ({year, limit}: {year: number; limit: number}) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.EXTERNAL_COSTS, year, limit],
        queryFn: ({pageParam = 1}) =>
            httpGetExternalCosts({
                params: {
                    year,
                    page: pageParam,
                    limit
                }
            }),
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })

    return {
        ...query,
        fetchNextPage: () => infiniteQueryFetchNextPage(query),
        remappedData: query.data?.pages[0]?.data?.length ? query.data.pages.flatMap(page => page.data) : []
    }
}
